import { trackEvent } from "../../track";
import getPageName from "../../helpers/track/getPageName";

const test = ({ target }) => target.closest("[data-bv-show='rating_summary']");

const push = ({ target }) => {
    if (target.classList.contains("bv_button_buttonMinimalist")) {
        trackEvent({
            event: "click_add_review",
            event_type: "click",
            item_name: document.querySelector("h1")?.textContent || getPageName() || ""
        });
    } else if(target.classList.contains("bv_main_rating_button")) {
        trackEvent({
            event: "click_read_review",
            event_type: "click",
            item_name: document.querySelector("h1")?.textContent || getPageName() || ""
        });
    }
}

export default {
  name: "bv-rating-summary",
  test,
  push
};